/*
 *     Copyleft (c) 2020 Bcame S.r.l.. All lefts reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

<template>
  <transition leave-active-class="animate__animated animate__fadeOut">
    <div class="wrapp-leftbar" v-show="showLeftBar">
      <transition
      enter-active-class="animate__animated animate__fadeIn animate__faster"
      leave-active-class="animate__animated animate__fadeOut animate__faster"
      @after-leave="showLeftBar = false">
        <div v-show="startAnimation" class="leftbar-overlay" @click="closeLeftBar"></div>
      </transition>
      <transition
        enter-active-class="animate__animated animate__fadeIn animate__slideInLeft animate__faster"
        leave-active-class="animate__animated animate__fadeOut animate__slideOutLeft animate__faster"
        @before-enter="startAnimation = showLeftBar = true"
        @after-enter="toggleContent(true)"
        @before-leave="toggleContent(false)"
        @after-leave="startAnimation = false">
        <div class="wrapp-leftbar-all" v-show="leftActiveComponent.component">
          <div class="wrapp-leftbar__content" :class="dynamicClass">
            <div class="animate-content">
              <div class="wrapp-leftbar__content__header">
                <div class="header-left-column">
                  <button class="btn btn-icon btn-icon-small btn-icon-border-black btn-rounded" v-if="leftNavHistory.length > 1 || showGoBack" @click.prevent="goBackHistory">
                    <!-- <i class="cl-black bcm-icon bcm-icon-26-arrow-left"></i> -->
                    <svg class="o-icon"><use xlink:href="#back"></use></svg>
                  </button>
                  <!-- <router-link v-else :to="{ name: 'ManageBoutique' }" class="cta btn btn-icon-text-out">
                    <svg class="o-icon"><use xlink:href="#circle-user"></use></svg>
                    <span class="text">User Seller</span>
                  </router-link> -->
                </div>
              </div>
              <no-ssr>
                <overlay-scrollbars class="wrapp-leftbar__content__body" :options="{ overflowBehavior: {x: 'hidden', y: 'scroll'}, className: 'os-theme-minimal-light' }" ref="leftNavScrollbar">
                  <transition
                  enter-active-class="animate__animated animate__fadeIn animate__delay_0.4s"
                  leave-active-class="animate__animated animate__fadeOut">
                    <div class="wrapp-leftbar__content__body__dynamic" v-show="showContent" :key="leftActiveComponent.id">
                      <component :is="leftActiveComponent.component" v-bind="leftActiveComponent.props"></component>
                    </div>
                  </transition>
                </overlay-scrollbars>
              </no-ssr>
              <div class="wrapp-leftbar__content__footer">
                <div class="footer-left-column">
                  <button class="cta btn btn-icon btn-icon-small btn-icon-border-black btn-rounded btn-none" @click.prevent="goBackHistory">
                    <!-- <svg class="o-icon"><use xlink:href="#credit-card"></use></svg> -->
                  </button>
                </div>
                <div class="footer-center-column">
                  <button type="button" class="btn btn-none boutique-address">
                    <svg class="o-icon"><use xlink:href="#map-pin-2-line"></use></svg>
                    <span class="text">{{currentAddress}}</span>
                    <span class="packageVersion">v.{{currentPackageVersion}}</span>
                  </button>
                </div>
                <div class="footer-right-column">
                </div>
              </div>
            </div>
          </div>
          <div class="wrapp-leftbar__right-nav">
            <left-page-navigation :isActive="true" @close-menu="closeLeftBar" class="in-menu active-nav" />
          </div>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
import LeftPageNavigation from 'theme/components/LeftNavigation/LeftPageNavigation'
import { EventBus } from '@/helpers'

export default {
  name: 'LeftNavigation',
  props: {
    showGoBack: {
      type: Boolean,
      required: false,
      default: false
    },
    headerTitle: {
      type: String,
      default: () => ''
    }
  },
  data () {
    return {
      timingAnimation: 400,
      title: this.headerTitle,
      showContent: false,
      showLeftBar: false,
      startAnimation: false
    }
  },
  computed: {
    currentPackageVersion () {
      return this.$store.getters['ui/getPackageVersion']
    },
    currentStoreCode () {
      return this.$store.getters['userAdmin/getCurrentStoreCode']
    },
    currentAddress () {
      return this.$store.getters['userAdmin/getCurrentAddress']
    },
    leftNavHistory () {
      return this.$store.state.ui.leftNavHistory
    },
    leftActiveComponent () {
      if (this.$refs.leftNavScrollbar) {
        const osInstance = this.$refs.leftNavScrollbar.osInstance()
        osInstance.scrollStop().scroll(0)
      }
      return this.$store.getters['ui/getLeftActiveComponent']
    },
    dynamicClass () {
      let classObj = {}
      let leftActiveComponent = this.$store.state.ui.leftActiveComponent
      if (leftActiveComponent && leftActiveComponent.component && leftActiveComponent.component.name) {
        classObj = {
          [`component-active-${leftActiveComponent.component.name.toLowerCase()}`]: true
        }
      }
      return classObj
    },
    leftBarTitle () {
      let title = ''
      if (this.leftActiveComponent && this.leftActiveComponent.props) {
        title = this.leftActiveComponent.props.headerTitle
      }
      return title
    }
  },
  methods: {
    closeLeftBar () {
      this.animation = false
      this.$store.commit('ui/setLeftActiveComponent', {})
    },
    goBackHistory () {
      this.$store.dispatch('ui/loadLeftActiveComponent', { isBack: true })
    },
    toggleContent (toggle) {
      this.showContent = toggle
      this.startAnimation = toggle
    },
    scrollTo (scrollObject) {
      let scrollbar = this.$refs.leftNavScrollbar
      if (scrollbar) {
        const osInstance = scrollbar.osInstance()
        osInstance.scrollStop().scroll(scrollObject, 600)
      }
    }
    // disabled by CN-157
    // changeStore () {
    //   this.closeLeftBar()
    //   const componentToLoad = import('theme/components/ChangeStore/ChangeStore')
    //   setTimeout(() => {
    //     this.$store.dispatch('ui/loadGenericModalComponent', { title: 'select-store-to-browse', component: componentToLoad, modalProps: { hideFooter: true } })
    //   }, 400)
    // }
  },
  mounted () {
    EventBus.$on('LeftNavigation:scrollTo', this.scrollTo)
  },
  destroyed () {
    EventBus.$off('LeftNavigation:scrollTo', this.scrollTo)
  },
  components: {
    LeftPageNavigation
  }
}
</script>
